import styles from "./CardSection.module.css";

const CardSection = ({
    title,
    description,
    children,
}) => {

    return (

        <section className={styles.card}>

            <header className={styles.header}>

                <h3 className={styles.title}>
                    {title}
                </h3>

                {

                    description && (

                        <p className={styles.description}>
                            {description}
                        </p>

                    )

                }

            </header>

            <div className={styles.body}>

                {children}

            </div>

        </section>

    );

};

export default CardSection;